export const Connector = () => (
  <div className="p-1">
    <div className="bg-badge h-[8px] w-0.5 rounded-full"></div>
  </div>
);
